import { FC } from 'react';
import clsx from 'clsx';
import { CatalogInterface, ProductDraftRequestPayload } from '@interfaces/models/deposit';
import styles from './universe-selector.module.scss';

type UniverseSelectorProps = {
  universes: CatalogInterface[];
  handleChangeUniverse: (e: React.ChangeEvent<HTMLInputElement>) => void;
  listingDraftPayload: ProductDraftRequestPayload;
};

export const UniverseSelector: FC<UniverseSelectorProps> = ({
  universes,
  handleChangeUniverse,
  listingDraftPayload,
}) => {
  return (
    <div
      className={clsx('vc-formUnit', styles.depositForm__form__fieldList, 'vc-text-m')}
      onChange={handleChangeUniverse}
    >
      {universes.length > 0 &&
        universes?.map((item, index) => (
          <label
            key={`${item.title}`}
            className={clsx(styles.depositForm__form__field, {
              [styles['depositForm__form__field--selected']]: listingDraftPayload.universe === item.id,
            })}
            htmlFor={`${item.title}-${index}`}
          >
            <input
              id={`${item.title}-${index}`}
              type="radio"
              name="universe"
              value={item.id}
              defaultChecked={item.id === listingDraftPayload.universe}
              className={clsx('vc-radio__input')}
              data-input-text-value={item.title}
            />
            <span className={clsx(styles.depositForm__form__universeLabel, 'vc-radio__label')}>{item.title}</span>
          </label>
        ))}
    </div>
  );
};
